import useCustomHook from '@/hooks/useCustomHook';
import { findCueByTime } from '@/modules/timeCues/timeCues';
import { useEffect } from 'react';

export default function useCues({
  currentTime,
  progressInterval,
  cues,
  pauseOnCue,
  onCue,
  onCueEnd,
  pause,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      activeCue: null,
      cues: null,
    },
  });

  useEffect(() => {
    actions.setState({ cues, activeCue: null });
  }, [cues]);

  useEffect(() => {
    if (state.cues && (onCue || onCueEnd)) {
      const detectedCue = findCueByTime(
        currentTime,
        state.cues,
        progressInterval
      );
      if (detectedCue && detectedCue.id != state.activeCue?.id) {
        actions.setState({
          activeCue: detectedCue,
        });
        if (onCue) onCue(detectedCue);
        if (pauseOnCue) pause();
      } else if (
        state.activeCue &&
        (currentTime > state.activeCue.time + progressInterval / 1000 ||
          currentTime < state.activeCue.time - progressInterval / 1000)
      ) {
        actions.setState({ activeCue: null });
        if (onCueEnd) onCueEnd();
      }
    }
  }, [state.cues, currentTime]);
}
